import { render, staticRenderFns } from "./EditTable.vue?vue&type=template&id=c1183af8&"
import script from "./EditTable.vue?vue&type=script&lang=js&"
export * from "./EditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1183af8')) {
      api.createRecord('c1183af8', component.options)
    } else {
      api.reload('c1183af8', component.options)
    }
    module.hot.accept("./EditTable.vue?vue&type=template&id=c1183af8&", function () {
      api.rerender('c1183af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Portal/components/EditTable.vue"
export default component.exports